export default __webpack_public_path__ + "static/media/icon-activity-notificationreceived.e8958717.svg";